import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { sanitizeReturnTo } from '../utils/sanitizeReturnTo';

interface PublicRouteProps {
  children: React.ReactNode;
}

/**
 * Route for public pages (like login).
 * Redirects authenticated users to their intended destination or root.
 */
export const PublicRoute: React.FC<PublicRouteProps> = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const [searchParams] = useSearchParams();

  if (isAuthenticated) {
    const returnTo = sanitizeReturnTo(searchParams.get('returnTo'));
    return <Navigate to={returnTo} replace />;
  }

  return <>{children}</>;
};

export default PublicRoute;